module.exports = __webpack_public_path__ + "img/点击评选.d80cdd2c.png";